<template>
  <modal v-model="value.show">
    <div slot="content">
      <div class="ls-modal-header">
        <button data-dismiss="modal" close-modal>&times;</button>
        <h4 class="ls-modal-title">{{ $t('contracts.modal_confirm_changes.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div class="ls-alert-warning">
          <strong>{{ $t('application.alert.warning') }}</strong> {{ $t('contracts.modal_confirm_changes.atention') }}
        </div>
        <div v-html="$t('contracts.modal_confirm_changes.message')"></div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn" close-modal data-dismiss="modal"><i class="fa fa-arrow-left" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('contracts.modal_confirm_changes.buttons.come_back') }}</span></button>
        <button type="submit" class="ls-btn-primary ls-float-right" @click.prevent="confirmChanges()"><i class="fa fa-check" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('contracts.modal_confirm_changes.buttons.confirm')}}</span></button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'

  export default {
    props: ['value'],
    components: { Modal },
    methods: {
      confirmChanges () {
        this.clearFlash
        this.$parent.validateBeforeSubmit()
        this.afterAction()
      },
      afterAction () {
        this.value.show = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ModalConfirmChanges.vue?0ce535f2